import * as React from "react"
import { useEffect } from "react"
import { Skeleton } from "@mui/material"

import { ADMIN_ROUTES } from "@constants"
import { isLoadingCommonFilters } from "@signals"
import PageWrapper from "Pages/@PageWrapper"
import { useAdminScrapingDataReviewSubmits } from "./@hooks"
import { resetAdminScrapingDataReview } from "./@signals"
import AdminScrapingDataReviewContent from "./Content"
import AdminScrapingDataReviewDetailsDrawer from "./Details"
import AdminScrapingDataReviewFilters from "./Filters"


export default function AdminScrapingDataReviewPage() {
    const { adminScrapingDataReviewIsEmpty, adminScrapingDataReviewShowTable, handleSubmitFilters } = useAdminScrapingDataReviewSubmits()

    useEffect(() => {
        return resetAdminScrapingDataReview()
    }, [])

    return <PageWrapper
        head={`${ADMIN_ROUTES.SCRAPING_DATA_REVIEW_TITLE}`}
        title={ADMIN_ROUTES.SCRAPING_DATA_REVIEW_TITLE}
        actions={null}
        isEmpty={adminScrapingDataReviewIsEmpty.value}
        filters={<AdminScrapingDataReviewFilters onSubmit={handleSubmitFilters} />}
    >
        {!!isLoadingCommonFilters.value && <Skeleton variant="rectangular" height={700} />}
        {!!adminScrapingDataReviewShowTable.value && <AdminScrapingDataReviewContent />}

        <AdminScrapingDataReviewDetailsDrawer />
    </PageWrapper>
}